import React from "react"
import { Link } from "gatsby"
import rightArrow from "../images/btn-arrow-right.svg"
import * as styles from "./topBannerTwo.module.scss"
// top_banner_two_space
const TopBannerTwo = () => {
  return (
    <div className={styles.top_banner_two} style={{display:'none'}}>
      <div className={styles.banner_content}>
        <span className={styles.banner_title}>
          Gartner®: Hype Cycle™ for Security Operations, 2022{" "}
        </span>
        <Link
          /*to="/black-hat">*/ to="/gartner-hype-cycle"
          className={styles.banner_link_btn}
        >
          {/*<p className={styles.banner_link_name}>Request a Meeting</p>*/}
          <p className={styles.banner_link_name}>Get the Report </p>
          <img src={rightArrow} alt="arrow btn" />
        </Link>
      </div>
    </div>
  )
}

export default TopBannerTwo
